// extracted by mini-css-extract-plugin
export default {"form":"gUGia55RjigRc3b5_noo","range":"PIkpgGu3YlxzwF_jfcSU"};